import { PairGraph } from "./graph";
import { gql } from "apollo-boost";
import { CitationData } from "./shared";
export const GroundingFragment = gql`
  fragment Grounding on Grounding {
    sentences {
      sentence
      statements {
        id
        runningIndex
        statement
        wordIndexForReferencePoint
        wordsIndices
        elementA {
          element
          match
          diff
        }
        hypothesis
        elementB {
          element
          match
          diff
        }
        connectionStrength
        #        reference {
        #          graph {
        #            ...PairGraph
        #          }
        #        }
        edgesWithTextualReferences {
          priority
          rvWithTextualReference {
            priority
            textual
            ruleValue {
              citationsObj {
                ...CitationData
              }
            }
          }
        }
      }
    }
    debugData
  }
  ${CitationData}
`;

export const GroundingQuery = {
  Grounding: gql`
    query groundText($text: String!, $caseId: String) {
      groundText(text: $text, caseId: $caseId) {
        ...Grounding
      }
    }
    ${GroundingFragment}
  `,
};
